module.exports = __webpack_public_path__ + "c91deaf74abc9377a6e21d1abe0b5a47.fbx";